module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "file-list"
  }, [_c('table', {
    staticClass: "table file-list"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.folders), function(folder) {
    return _c('tr', {
      staticClass: "frow",
      on: {
        "click": function($event) {
          return _vm.goToFolder($event, folder)
        }
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('td', {
      staticClass: "name"
    }, [_vm._v(_vm._s(folder.name))]), _vm._v(" "), _c('td')])
  }), _vm._v(" "), _vm._l((_vm.files), function(file) {
    return _c('tr', {
      staticClass: "frow file-row",
      on: {
        "click": function($event) {
          return _vm.handleMetadataClick(file)
        }
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('td', {
      staticClass: "name"
    }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('td')])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "icon-col"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "icon fa fa-folder-o fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "icon fa fa-file-o fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b19f564"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FileList.vue
// module id = 426
// module chunks = 1